import React from 'react';

function StatusBanner({ monitoring, user, onStartMonitoring, onStopMonitoring }) {
  if (!user) {
    return (
      <div className="banner banner-warning">
        <span>로그인이 필요합니다. 크몽 계정으로 로그인해주세요.</span>
      </div>
    );
  }

  return (
    <div className={`banner ${monitoring ? 'banner-success' : 'banner-info'}`}>
      <div className="banner-content">
        <span className="banner-text">
          {monitoring ? '🟢 모니터링 중...' : '⚪ 모니터링 대기 중'}
        </span>
        <button
          className={`btn ${monitoring ? 'btn-danger' : 'btn-primary'}`}
          onClick={monitoring ? onStopMonitoring : onStartMonitoring}
        >
          {monitoring ? '모니터링 중지' : '모니터링 시작'}
        </button>
      </div>
    </div>
  );
}

export default StatusBanner;
